export enum FileMime {
  Excel,
  Pdf,
  Ppt,
  Other,
}
